import React from 'react';

const WhoSection = () => {
  return (
    <section 
      className="py-16 md:py-20 text-center text-white"
      style={{
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url(/13.jpg)',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        minHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div className="container mx-auto px-4">
        <h2 className="font-bold text-2xl md:text-4xl mb-4">Who is it for?</h2>
        <h3 className="text-xl md:text-2xl mt-4 font-semibold text-yellow-300">ANY Teen from Age 13–19</h3>
        <h4 className="text-lg md:text-xl mt-3 font-medium">NO Height Barrier</h4>
      </div>
    </section>
  );
};

export default WhoSection;